module.exports = __webpack_public_path__ + "static/media/profile-bg.5573c7e7.jpg";